import { ShimmerText } from "@narmi/design_system";
import { useState } from "react";
import styles from "./style.module.css";

export const ThreadSummary = ({
  summary,
  loading,
}: {
  summary: string | undefined;
  loading: boolean;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={styles.threadSummaryContainer}>
      <span className="narmi-icon-corner-down-right" />
      {loading ? (
        <ShimmerText text="Thinking..." />
      ) : (
        <>
          <div className={isExpanded ? styles.threadSummaryTextExpanded : styles.threadSummaryText}>
            {summary ?? ""}
          </div>
          <span
            className={isExpanded ? "narmi-icon-chevron-up" : "narmi-icon-chevron-down"}
            role="button"
            tabIndex={0}
            aria-label={isExpanded ? "Collapse thread summary" : "Expand thread summary"}
            aria-expanded={isExpanded}
            onClick={() => setIsExpanded((prev) => !prev)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setIsExpanded((prev) => !prev);
              }
            }}
          />
        </>
      )}
    </div>
  );
};
